import {RestMsg} from "./rest-msg.model";

export class ErrorsWarnings {
  errors: RestMsg[];
  warnings: RestMsg[];
}

